import { Col, Row } from "../../ApiS/Grid-system/Grid-system";

interface CardProps {
  image: string;
  title: string;
  sum: number;
}

const Card: React.FC<CardProps> = ({ image, title, sum }) => {
  return (
    <>
      <Row className="border-2 py-2 !mx-2 rounded-2xl">
        <Col sm={3} md={3} lg={3} className="!mx-2 max-md:!mt-1">
          <img src={image} className="mt-2 max-lg:!w-14" />
        </Col>
        <Col sm={8} md={8} lg={8} className="!mt-2  ">
          <h1 className="font-semibold  "> {title}</h1>
          <h3 className="font-bold text-sm mt-2">{sum} طالب</h3>
        </Col>
      </Row>
    </>
  );
};

export default Card;
